// removed by extract-text-webpack-plugin
module.exports = {"Base":"SpecialSeriesRollup__Base-2cHLJ","Articles":"SpecialSeriesRollup__Articles-1LN3t","Article":"SpecialSeriesRollup__Article-38Kdx","Link":"SpecialSeriesRollup__Link-2a215","Title":"SpecialSeriesRollup__Title-W3Pwj","Content":"SpecialSeriesRollup__Content-1NREt","Footer":"SpecialSeriesRollup__Footer-DEk7E","FooterLink":"SpecialSeriesRollup__FooterLink-35YI0"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SpecialSeriesRollup/SpecialSeriesRollup.css
 ** module id = 644
 ** module chunks = 0
 **/